import _defineProperty from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import * as React from 'react';
import { Button, Icon, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, Typography, withStyles } from '@material-ui/core';
import styles from './Dialog.styles';
import Loader from '../loader/Loader';
import { Close } from '@material-ui/icons';
import classnames from 'classnames';

var renderButtons = function renderButtons(buttons, classes) {
  if (buttons && buttons.length) {
    return React.createElement(DialogActions, {
      className: classes.buttons
    }, buttons.map(function (button, index) {
      return React.createElement(Button, {
        key: "dialog-button-".concat(index),
        color: button.color || 'primary',
        variant: 'contained',
        size: button.size || 'small',
        onClick: button.func
      }, button.icon && React.createElement(Icon, {
        fontSize: 'small',
        className: classes.buttonLeftIcon
      }, button.icon), button.label);
    }));
  }

  return null;
};

function Modal(props) {
  var _classnames;

  var title = props.title,
      children = props.children,
      classes = props.classes,
      onClose = props.onClose,
      open = props.open,
      disableEnforceFocus = props.disableEnforceFocus,
      confirm = props.confirm,
      onConfirm = props.onConfirm,
      loading = props.loading,
      fullWidth = props.fullWidth,
      buttons = props.buttons,
      slim = props.slim;
  return React.createElement(Dialog, {
    open: open,
    onClose: onClose,
    "aria-labelledby": 'alert-dialog-title',
    "aria-describedby": 'alert-dialog-description',
    fullWidth: fullWidth,
    maxWidth: 'md',
    disableEnforceFocus: Boolean(disableEnforceFocus)
  }, title && React.createElement(DialogTitle, {
    disableTypography: true,
    className: classnames(classes.title, (_classnames = {}, _defineProperty(_classnames, classes.titleWithClose, onClose), _defineProperty(_classnames, classes.titleSlim, slim), _classnames))
  }, React.createElement(Typography, {
    variant: slim ? 'subtitle2' : 'h6'
  }, title), onClose ? React.createElement(IconButton, {
    "aria-label": 'Close',
    className: classnames(classes.close, _defineProperty({}, classes.closeSlim, slim)),
    onClick: onClose,
    size: slim ? 'small' : undefined
  }, React.createElement(Close, {
    fontSize: slim ? 'small' : undefined
  })) : null), children && React.createElement(DialogContent, {
    className: classes.content
  }, confirm && onConfirm ? React.createElement(DialogContentText, null, children) : children), confirm && onConfirm && React.createElement(DialogActions, null, React.createElement(Button, {
    onClick: onClose,
    color: 'primary',
    size: slim ? 'small' : undefined
  }, "\u041D\u0435\u0442"), React.createElement(Button, {
    onClick: onConfirm,
    color: 'primary',
    size: slim ? 'small' : undefined,
    autoFocus: true
  }, "\u0414\u0430")), renderButtons(buttons, classes), loading && React.createElement("div", {
    className: classes.loading
  }, React.createElement(Loader, null)));
}

export default withStyles(styles, {
  name: 'Dialog'
})(Modal);